import { coreDialogApi } from '@cp/entities/dialog';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { SUPPORT_DIALOG_QUERY } from './const';

export const useSupportDialogUnreadCountQuery = () => {
  const isLoggedIn = useIsLoggedIn();
  const { data, isSuccess } = coreDialogApi.endpoints.getUnreadMessagesCount.useQuery(SUPPORT_DIALOG_QUERY, {
    skip: !isLoggedIn,
  });

  return {
    count: data?.count ?? 0,
    isReady: isSuccess,
  };
};

export const useSupportDialogUnreadCount = (): number => {
  return useSupportDialogUnreadCountQuery().count;
};
